import ApexCharts, { ApexOptions } from 'apexcharts'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useQuery } from 'react-query'
import { GetExportRankingWithMedicationsRegistrations, GETWatchedVideosByCompanyData } from '../core/_requests'
import { WatchedVideosByCompanyData } from '../core/_models'

type Props = {
  className: string
}

function getChartOptions(dataList: WatchedVideosByCompanyData[] = []): ApexOptions {
  return {
    series: [{
      data: dataList.map(item => ({ x: item.company, y: Number((Number(item.hours)).toFixed(2)) }))
    }],
    legend: { show: false },
    chart: {
      height: 350,
      width: '100%',
      type: 'treemap'
    },
    title: {
      text: 'Top 10 - Crianças que mais usaram',
      align: 'center',
      style: {
        color: 'gray',
        fontSize: '20px',
      }
    },
    plotOptions: {
      treemap: {
        distributed: true,
        enableShades: false,
      }
    },
  }
}

const EngageChart = ({ className }: Props) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const [isExporting, setIsExporting] = useState(false)

  const { data, isLoading } = useQuery(
    'watched-videos-by-company-chart',
    GETWatchedVideosByCompanyData, {
      cacheTime: 0,
      refetchOnWindowFocus: false
    }
  )

  const refreshChart = useCallback(() => {
    if (!chartRef.current || isLoading) return
    const chart = new ApexCharts(chartRef.current, getChartOptions(data || []))
    chart.render()
    return chart
  }, [data, isLoading])

  useEffect(() => {
    const chart = refreshChart()
    return () => { if (chart) chart.destroy() }
  }, [refreshChart])

  const handleExportExcel = async () => {
    try {
      setIsExporting(true)
      const response = await GetExportRankingWithMedicationsRegistrations()
      if (!response) throw new Error('Erro ao exportar arquivo')

      const url = window.URL.createObjectURL(response)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'ranking.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error('Erro ao exportar:', error)
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <div className={`card card-flush ${className}`}>
      <div
        className='card-body d-flex flex-column justify-content-between bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0'
        style={{ backgroundPosition: '100% 50%' }}
      >
       

        {!isLoading && (
          <div ref={chartRef} style={{ height: '350px', color: '#5b41f1' }} />
        )}

<div className="d-flex justify-content-end mb-4">
          <button
            className="btn btn-sm btn-primary"
            onClick={handleExportExcel}
            disabled={isExporting}
          >
            {isExporting && (
              <span className="spinner-border spinner-border-sm me-2" role="status" />
            )}
            {isExporting ? 'Exportando...' : 'Exportar Excel'}
          </button>
        </div>
      </div>
    </div>
  )
}

export { EngageChart }
